export default {
  head: {
    title: 'Top-up & Data operations billing',
    action: {
      create: {
        tooltip: 'Create new USSD report'
      },
      search: {
        tooltip: 'Search single operation by Operation Id'
      }
    }
  },
  footer: {
    label: 'Total cost',
    tooltip: 'Value from entire period including selected filters'
  },
  dialog: {
    search: {
      title: 'Search Top-up & Data billing operation'
    },
    details: {
      title: 'Operation details'
    }
  }
};
